// extracted by mini-css-extract-plugin
export var circle = "_3n-2";
export var icon = "_3n-a";
export var iconHighlight = "_3n-0";
export var lg = "_3n-8";
export var md = "_3n-7";
export var outline = "_3n-4";
export var sm = "_3n-6";
export var square = "_3n-1";
export var xl = "_3n-9";
export var xs = "_3n-5";
export var xxs = "_3n-3";